import React from 'react';
import { InfiniteWindowedGridLayout } from '@cld/react-window-layout';
import useImageSection from './useImageSection';
import { DEFAULT_GRID_IMAGE_WIDTH } from '~/src/root/components/ResultImageGrid/VirtualResultsGrid/const';
import { StyledResultsGridWrapper } from '~/src/root/components/ResultImageGrid/VirtualResultsGrid/VirtualResultsGrid.styled';

const VirtualResultsGrid = (props) => {
  const sections = [useImageSection(props)];

  return (
    <StyledResultsGridWrapper data-test="virtual-result-grid">
      <InfiniteWindowedGridLayout itemWidth={props.itemWidth || DEFAULT_GRID_IMAGE_WIDTH} sections={sections} />
    </StyledResultsGridWrapper>
  );
};

export default VirtualResultsGrid;
